<template>
  <div class="min-h-screen bg-gray-50 p-8">
    <!-- 筛选条件区域 -->
    <div class="mb-8 rounded-lg bg-white p-6 shadow-sm">
<!-- 修改外层容器为flex布局 -->
<div class="flex flex-nowrap items-center gap-4">  <!-- 关键修改 -->
  <div class="relative" v-if="isuse == 1" style="margin-right: 20px;">
    <!-- 供应商选择按钮保持不变 -->
    <button @click="toggleSupplierDropdown" class="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700 hover:bg-gray-50">
      <i class="fas fa-building"></i>
      <span class="whitespace-nowrap">{{ selectedSupplier.store_name || '选择店铺' }}</span>
      <i class="fas fa-chevron-down text-gray-400"></i>
    </button>
    <!-- 下拉菜单保持不变 -->
    <div v-if="showSupplierDropdown" class="absolute z-10 w-56 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
      <div class="py-2">
        <div v-for="item in supply" :key="item.supply_id" @click="selectSupplier(item)" class="px-4 py-2 hover:bg-gray-50 cursor-pointer">
          {{item.store_name}}
        </div>
      </div>
    </div>
  </div>

  <!-- 日期选择器容器 -->
  <div class="flex flex-nowrap items-center gap-2 flex-shrink-0">  <!-- 关键修改 -->
    <input 
      type="date" 
      v-model="form.startDate" 
      class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700"
    >
    <span class="text-gray-500">至</span>
    <input 
      type="date" 
      v-model="form.endDate" 
      class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700"
    >
  </div>

  <!-- 查询按钮 -->
  <button 
    @click="search" 
    class="!rounded-button flex items-center px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 flex-shrink-0"
    style="height: 36px;"
  >
    查询
  </button>
</div>
</div>


    <!-- 数据概览区域 -->
    <div class="mb-8 grid grid-cols-5 gap-6">
      <div v-for="(stat, index) in statistics" :key="index" class="rounded-lg bg-white p-6 shadow-sm">
        <div class="mb-2 text-sm text-gray-500">{{ stat.label }}</div>
        <div class="flex items-end gap-2">
          <span class="text-2xl font-bold text-gray-800">{{ stat.value }}</span>
          <span v-if="stat.unit" class="text-sm text-gray-500">{{ stat.unit }}</span>
        </div>
      </div>
    </div>


    <!-- 表格区域 -->
    <div class="rounded-lg bg-white shadow-sm">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="order_no" label="订单号"></el-table-column>
          <el-table-column prop="nickname" label="下单用户"></el-table-column>
          <el-table-column prop="pay_type" label="支付方式">
            <template #default="scope">
              {{ getPayTypeText(scope.row.pay_type) }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="支付金额"></el-table-column>
          <el-table-column prop="pay_status" label="支付状态">
            <template #default="scope">
              {{ getPayStatusText(scope.row.pay_status) }}
            </template>
          </el-table-column>
          <el-table-column prop="transaction_id" label="支付交易号"></el-table-column>
          <el-table-column prop="pay_time" label="支付时间"></el-table-column>
          <el-table-column 
            prop="is_refund" 
            label="退款"
            :formatter="(row) => ({
              0: '未申请退款',
              1: '申请退款',
              2: '申请退款审核通过',
              3: '申请退款审核不通过'
            }[row.is_refund] || row.is_refund)">
          </el-table-column>
          <el-table-column prop="canel_val" label="取消退款原因"></el-table-column>
          <el-table-column
            prop="is_settled" 
            label="结算状态"
            :formatter="(row) => ({
              0: '未结算',
              1: '已结算',
            }[row.is_settled] || row.is_settled)">
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template #default="scope">
              <el-button
                v-if="scope.row.is_refund === 0 || scope.row.is_refund === 1 || scope.row.is_refund === 3"
                type="text"
                size="small"
                @click="handleRefund(scope.row)">
                退款
              </el-button>
              <span v-if="scope.row.is_refund === 2">已退款</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background 
          :current-page="curPage"
          :page-sizes="[20, 100, 500, 1000]"
          layout="total,sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import StatisticsApi from '@/api/statistics.js';
import StoreApi from '@/api/store.js';
import qs from 'qs';

export default {
data() {
  return {
    selectedSupplier: {'name':""},
    showSupplierDropdown: false,
    startDate: '',
    endDate: '',
    supply:[],
    isuse:1,
    selectedSuppliers: {'store_name':""},
    showSupplierDropdowns: false,
    store:[],
    loading: true,
    tableData: [],
    storeList: [],
    form: {
      customerName: '',
      status: '',
      category: '',
      dateRange: '',
      startDate: '',
      endDate: '',
      store_id: '',
      search: '',
      order: "",
      time: ""
    },
    statistics: [
      { label: '订单总数', value: '', trend: 5 },
      { label: '订单总金额', value: '', unit: '元', trend: 12 },
      { label: '待发货订单', value: '', trend: -3 },
      { label: '本月订单数', value: '', trend: 8 }
    ],
    pageSize: 20,
    totalDataNumber: 0,
    curPage: 1,
    multipleSelection: [],
    dialogVisible: false,
    rejectForm: {
      pay_order_id: '',
      order_no: '',
      reject_val: ''
    }
  };
},
mounted() {
  this.search();
  this.loadStaticData();
  // this.initCharts();
},
methods: {
  loadStaticData() {
    StatisticsApi.getSupply().then((res)=>{
      this.supply = res.data.list.data
      console.log(this.supply);
      
      this.totalDataNumber = this.tableData.length;
    })
    // this.supply = [
    //   { supply_id: 1, name: '供应商A' },
    //   { supply_id: 2, name: '供应商B' }
    // ];
    
    // this.totalDataNumber = this.tableData.length;
  },
  
  async search() {
    try {
      // 调用统计接口
      const res = await StatisticsApi.orderStatistics({
        startDate: this.form.startDate,
        endDate: this.form.endDate
      });
      
      // 更新统计数据
      this.statistics = [
        { label: '订单总数', value: res.data.statistics.total_orders },
        { label: '订单总金额', value: '¥' + res.data.statistics.total_amount.toLocaleString(), unit: '元' },
        { label: '本月订单数', value: res.data.statistics.month_orders }
      ];
      
      
      // 获取表格数据
      this.getTableList();
      
    } catch (error) {
      console.error('获取统计数据失败:', error);
      this.$message.error('获取数据失败');
    }
  },
  
  initCharts(data) {
    const orderTrendChart = echarts.init(this.$refs.orderTrendChart);
    orderTrendChart.setOption(data.order_trend);
    
    const categoryChart = echarts.init(this.$refs.categoryChart);
    categoryChart.setOption(data.payment_distribution);
  },
  
  getTableList() {
    let self = this;
    let Params = self.form;
    Params.page = self.curPage;
    Params.list_rows = self.pageSize;
    self.loading = true;
    
    StoreApi.payOrderlist(Params, true)
      .then(data => {
        self.loading = false;
        self.tableData = data.data.list;
        self.totalDataNumber = data.data.list.total || 0;
      })
      .catch(error => {
        self.loading = false;
      });
  },
  
  handleCurrentChange(val) {
    this.curPage = val;
    this.getTableList();
  },
  
  handleSizeChange(val) {
    this.curPage = 1;
    this.pageSize = val;
    this.getTableList();
  },
  
  handleSelectionChange(e) {
    this.multipleSelection = e;
  },
  
  handleRefund(row) {
    this.$confirm('确定要退款吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      StoreApi.approveRefund({
        order_id: row.pay_order_id
      }).then(response => {
        this.$message.success(response.msg);
        this.getTableList();
      }).catch(error => {
        this.$message.error(error.message || '退款失败');
      });
    }).catch(() => {
      this.$message.info('已取消退款');
    });
  },
  
  getPayTypeText(type) {
    const payTypeMap = {
      10: '余额',
      20: '微信',
      30: '支付宝',
      40: '花呗',
      50: 'app微信',
      60: 'app支付宝'
    };
    return payTypeMap[type] || type; 
  },
  
  getPayStatusText(status) {
    const statusMap = {
      10: '待支付',
      20: '已支付',
      30: '退还已返还',
    };
    return statusMap[status] || status;
  },
  
  toggleSupplierDropdown() {
    this.showSupplierDropdown = !this.showSupplierDropdown;
  },
  
  selectSupplier(supplier) {
    this.selectedSupplier = supplier;
    this.showSupplierDropdown = false;
    this.form.store_id = supplier.supply_id;
  }
}
};
</script>

<style scoped>
/* 移除number input的箭头 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
-webkit-appearance: none;
margin: 0;
}
input[type="number"] {
-moz-appearance: textfield;
}

.modal-mask {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: rgba(0,0,0,0.5);
display: flex;
justify-content: center;
align-items: center;
z-index: 1000;
}

.modal-container {
background: white;
padding: 20px;
border-radius: 8px;
width: 400px;
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/report/caiwur.vue